module.exports = __webpack_public_path__ + "542b19678bc3760b9463cca97f041287.svg";